var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassedIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 33.75,
    fill: "#BDE541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7451 49.4579L58.6606 30L63.75 35.4657L39.7451 60L26.25 46.1905L31.3259 40.9194L39.7451 49.4579Z",
    fill: "#193051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedIconBlue);
export default __webpack_public_path__ + "static/media/passed-icon-blue.830fb4b2518a6a44e97a8f60609c77af.svg";
export { ForwardRef as ReactComponent };